import { getPublic } from "../../data/api";

export async function getSignNowSignature(rentalId) {
    return await getPublic('public/signnow/signature/' + rentalId);
}
